import { render, staticRenderFns } from "./MyCustomer.vue?vue&type=template&id=5843f251&scoped=true"
import script from "./MyCustomer.vue?vue&type=script&lang=js"
export * from "./MyCustomer.vue?vue&type=script&lang=js"
import style0 from "./MyCustomer.vue?vue&type=style&index=0&id=5843f251&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5843f251",
  null
  
)

export default component.exports